import { render, staticRenderFns } from "./FormTaxPph4Verse2.vue?vue&type=template&id=b9f02e20"
import script from "./FormTaxPph4Verse2.vue?vue&type=script&lang=js"
export * from "./FormTaxPph4Verse2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports